import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import {
  Course_Table_Model,
  Courses_Form_Model,
} from "../../Models/CoursesModel";
import { COURSE_SINGLE_DATA } from "../../Actions/courseAction";
import { useDispatch, useSelector } from "react-redux";
import { LIST_CAMPUS_BY_COURSE_ID } from "../../Actions/campusAction";
import { useEffect } from "react";

export default function CourseTableRow({
  Course_Id,
  Course_Name, // string
  Campus_Id,
  CampusNames, // dropdown - have to pass only id
  University_Id,
  University_Name,
  Country, // dropdown - have to pass only id
  Course_Url, // string
  Intakes, // dropdown - have to pass only id
  Duration, // int
  Yearly_Tuition_Fees, // dropdown - have to pass only id
  IELTS_Required, // string
  PTE_Required, // string
  TOEFL_Required, // string
  GRE_Required, // string
  GMAT_Required, //string
  Duolingo_Required, //string
  Entry_Requirement, // string - classic editor
  Application_Fees, // int
  Application_Deadline,
  Study_Level, // string
  IELTS_Score, // dropdown - from 4.0 to 9.0 difference of 0.5
  Course_Type,
  duration_int,
  handleEditCourseData,
  handleDeleteCourse,
}) {
  const dispatch = useDispatch();

  const data = [
    "delete",
    Course_Name,
    CampusNames,
    University_Name,
    Country,
    Course_Url,
    Duration,
    Yearly_Tuition_Fees,
    Application_Fees,
    Application_Deadline,
    IELTS_Required,
    PTE_Required,
    TOEFL_Required,
    GRE_Required,
    GMAT_Required,
    Duolingo_Required,
    IELTS_Score,
    Study_Level,
  ];

  const handleEdit = (e) => {
    e.preventDefault();
    handleEditCourseData(Course_Id);
    dispatch(COURSE_SINGLE_DATA(Course_Id));
    dispatch(LIST_CAMPUS_BY_COURSE_ID(Course_Id));
  };

  // console.log(CampusNames);

  // Handle Delete Table function

  const handleDelete = (e) => {
    e.preventDefault();
    handleDeleteCourse(Course_Id);
  };

  return (
    <tr>
      {Course_Table_Model?.map((el, i) => (
        <td key={i}>
          {data[i] === "delete" ? (
            <span className={data[i] === "delete" ? "Edit_Delete" : ""}>
              <span onClick={(e) => handleEdit(e)}>
                <TbEdit />
              </span>
              <span onClick={handleDelete}>
                <MdDelete />
              </span>
            </span>
          ) : (
            data[i]
          )}
        </td>
      ))}
    </tr>
  );
}
